import React from 'react'
import { useTranslations } from 'next-intl'
import { Box, Button, Flex, Text } from '@chakra-ui/react'
import { CheckIcon } from '@chakra-ui/icons'
import { useAddToCart } from '@/hooks/useAddToCart'
import { useCart } from '@/hooks/useCart'
import { isProductInCart } from '@/utils/isProductInCart'
import { formatPrice } from '@/utils/formatPrice'
import { IMinerNode } from '@/types/miner.interface'

type AddToCartCellProps = {
  rowData: IMinerNode
}

export const AddToCartCell = ({ rowData }: AddToCartCellProps) => {
  const t = useTranslations()
  const { cart } = useCart()
  const productInCart = isProductInCart(rowData.productId, cart)

  const [alterCartMutation, { loading: alterCartLoading }] = useAddToCart({
    productId: rowData.productId,
  })

  return (
    <Flex
      alignItems={'center'}
      justifyContent="space-between"
      width="full"
      my="2"
    >
      <Text>
        {formatPrice(
          rowData.productListingPrice,
          rowData.productListingPrice < 1
        )}
      </Text>
      <Button
        variant="darkBrand"
        borderRadius={'lg'}
        w="121px"
        h="10"
        onClick={alterCartMutation}
        isLoading={alterCartLoading}
        className="gtm-add-to-cart"
        isDisabled={productInCart}
        pl="4"
      >
        {productInCart ? (
          <Box color="black" display="flex" alignItems="center" gap="2">
            <CheckIcon />
            {t('buttons.added')}
          </Box>
        ) : (
          t('buttons.add-cart')
        )}
      </Button>
    </Flex>
  )
}
